module.exports = __webpack_public_path__ + "static/img/arrowSuc.ceb31c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrowSuc.png
// module id = yWWv
// module chunks = 1